// Module
var code = "<search></search> <announcements></announcements> <menu></menu> <alert-message ng-if=\"$ctrl.showAlert\" text=\"{{$ctrl.alertMessage}}\" local-storage-name=\"alert-message\"></alert-message> <div block-ui=\"root\" class=\"root\"> <ui-view></ui-view> </div> ";
// Exports
module.exports = code;